var axios = require('axios')
const prefixLocalisation = '/product-localisation/'
const prefixfe = process.env.version + '/product-hut-fe/'
const prefixfe_v2 = process.env.version2 + '/product-hut-fe/'

/**
 * Get list outLets for take-away or a outlet for delivery
 * */
axios.checkLocation = function (data, success, callBackError) {
  this.get(prefixfe + 'localizations', {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}
/**
 * Get list outLets by postal code
 * */
axios.getNextLevelData = function (data, success, callBackError) {
  axios.options.flag = false
  this.get(prefixLocalisation + 'search', {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

/**
 * Checking Outlet is available
 * */
axios.checkOutletAvailable = function (data, success, callBackError) {
  axios.options.flag = false
  axios.options.notify = false
  this.post(prefixfe_v2 + 'outlets/available', data).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

/**
 * Checking Outlet is available
 * */
axios.getOutletDetail = function (data, success, callBackError) {
  axios.options.flag = false
  axios.options.notify = false
  this.get(prefixfe_v2 + 'outlets/detail/'+ data.outlet_code).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

/** https://api.phdvasia.com/v1/product-hut-fe/opening_hours_summary/5?order_type=C
 * Get outlet's opening hours
 * */
axios.getOutletOpeningHours = function (data, success, callBackError) {
  axios.options.flag = false
  axios.options.notify = false
  this.get(prefixfe_v2 + 'outlets/opening_hours/' + data.outletId, {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

/**
 * Get outlets by address code or zipcode or outletid
 * */
axios.getOutletByAddressCode = function (data, success, callBackError) {
  this.get(prefixfe + 'mappings', {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

/**
 * Get outlets by outlet code
 * */
axios.getOutLetByCode = function (data, success, callBackError) {
  this.get(prefixfe + 'outlets/detail/' + data.code, {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 404 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.getAddressByAddressCode = function (data, success, callBackError) {
  this.get(prefixfe + 'address/', {params: data}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 404 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}
export default axios



// WEBPACK FOOTER //
// ./src/api/Outlet.js